(function handleScrollTop() {
  const btnScrollTop = document.querySelector('.btn-scroll-top');
  const multiPageContentNavigation = document.querySelector('.multi-page-book-navigation');

  if (!btnScrollTop) return;


  btnScrollTop.addEventListener('click', () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      btnScrollTop.classList.add('show');
    } else {
      btnScrollTop.classList.remove('show');
    }
  });

  if (multiPageContentNavigation) {
    btnScrollTop.style.bottom = '80px';
  }
})();
